export const setLoginError = (flag) =>
	({
		type    : 'SET_LOGIN_ERROR',
		payload : { flag }
	});
